import { useCallback } from "react"

import type { DialogCloseAction } from "@/types/common"

const useHandleCloseWithDataSave = (
  getValues: () => any,
  onClose: (params: { data: any; reason: DialogCloseAction }) => void
): (() => void) => {
  const handleClose = useCallback(() => {
    const data = getValues()
    onClose({ data, reason: "cancel" })
  }, [getValues, onClose])

  return handleClose
}

export default useHandleCloseWithDataSave
